import { inject, Injectable } from "@angular/core";
import { SessionApi } from "../Api/SessionApi";
import { SessionState } from "./SessionState";
import { SearchSessionRequest } from "../Dto/SessionSearchRequest";
import { createBackendError, getBackendErrorMessage } from "../../../Common/Utility/UtilityError";

@Injectable({ providedIn: "root" })
export class SessionEffects {
  private readonly sessionApi = inject(SessionApi);
  private readonly sessionState = inject(SessionState);

  async searchSessions(params: SearchSessionRequest = {}): Promise<void> {
    const mergedParams: SearchSessionRequest = {
      ...this.sessionState.searchParams(),
      ...params,
    };

    this.sessionState.setLoading(true);
    this.sessionState.setError(null);

    try {
      const response = await this.sessionApi.searchSessions(mergedParams);
      this.sessionState.setSessions(response.data, response.pagination);
      this.sessionState.setSearchParams(mergedParams);
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.sessionState.setError(errorMessage);
    } finally {
      this.sessionState.setLoading(false);
    }
  }

  async deleteSession(sessionId: string): Promise<boolean> {
    this.sessionState.setLoading(true);
    this.sessionState.setError(null);

    try {
      await this.sessionApi.deleteSession(sessionId);
      this.sessionState.removeSession(sessionId);
      return true;
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.sessionState.setError(errorMessage);
      throw createBackendError(exception);
    } finally {
      this.sessionState.setLoading(false);
    }
  }
}
